export default __webpack_public_path__ + "static/media/036-grave.9f5864eb.png";